import React from 'react';

import { Box, Typography } from '@mui/material';

import { formatCurrency, formatSignedPercent } from './toursPricingUtils';

type ToursCurrentPricingRow = {
  original_tour_price: number;
  current_tour_price?: number | null;
  current_price_delta_percent?: number | null;
  days_since_last_sale?: number | null;
};

function getCurrentSurchargeDiscountColor(value?: number | null): string {
  if (value == null || value === 0) {
    return 'text.secondary';
  }
  return value > 0 ? 'success.main' : 'error.main';
}

function getCurrentLivePrice(row: ToursCurrentPricingRow): number | null {
  if (row.current_tour_price != null) {
    return row.current_tour_price;
  }
  return row.original_tour_price;
}

function formatOptionalCount(value?: number | null): string {
  if (value == null) {
    return '—';
  }
  return value.toLocaleString();
}

function formatCurrentOverride(value?: number | null): string {
  if (value == null || value === 0) {
    return 'None';
  }
  return formatSignedPercent(value);
}

export default function ToursCurrentPricingFormatter({ row }: { row: ToursCurrentPricingRow }) {
  const currentLivePrice = getCurrentLivePrice(row);

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Base:
        </Typography>{' '}
        {formatCurrency(row.original_tour_price)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Current override:
        </Typography>{' '}
        <Typography
          component="span"
          variant="body2"
          color={getCurrentSurchargeDiscountColor(row.current_price_delta_percent)}
          fontWeight="medium"
        >
          {formatCurrentOverride(row.current_price_delta_percent)}
        </Typography>
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Current live:
        </Typography>{' '}
        {formatCurrency(currentLivePrice)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Days since last sale:
        </Typography>{' '}
        {formatOptionalCount(row.days_since_last_sale)}
      </Typography>
    </Box>
  );
}
